import PropTypes from 'prop-types';
import { PaxProps } from './Pax';
import { RoomsPaxProps } from './RoomsPax';

export const RoomsProps = PropTypes.arrayOf(PropTypes.oneOfType([RoomsPaxProps, PaxProps]));
